<template>
	<button aria-label="Back to homepage" class="logo" :class="[color, { hidden }]">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			width="31"
			height="31"
			viewBox="0 0 31 31"
		>
			<defs>
				<clipPath id="clip-path">
					<rect
						id="Rectangle_1277"
						data-name="Rectangle 1277"
						width="31"
						height="31"
						transform="translate(0 0.336)"
					/>
				</clipPath>
			</defs>
			<g id="Group_4740" data-name="Group 4740" transform="translate(0 -0.336)">
				<g id="Group_4738" data-name="Group 4738" clip-path="url(#clip-path)">
					<path
						id="Path_4583"
						data-name="Path 4583"
						d="M26.052,15.305l-1.819-1.819L26.25,11.47l3.835,3.835Zm-1.914,2.488,1.914-1.914h4.033L26.154,19.81Zm-2.969,2.969L23.732,18.2l2.016,2.016-2.563,2.563ZM18.2,23.732l2.563-2.563,2.017,2.017-2.563,2.563Zm-2.32,2.32,1.914-1.914,2.016,2.017-3.93,3.931Zm-2.394-1.819,1.819,1.819v4.033L11.47,26.25Zm-3.064-3.064,2.658,2.658-2.016,2.017L8.406,23.186ZM7.205,17.953l2.81,2.81L8,22.779l-2.81-2.81ZM5.133,15.88,6.8,17.546,4.783,19.563,1.1,15.88ZM6.7,13.734,5.133,15.305H1.1l3.588-3.588Zm3.312-3.312L7.11,13.328,5.094,11.311,8,8.406Zm2.969-2.969-2.563,2.563L8.406,8l2.563-2.563Zm2.32-2.32L13.391,7.047,11.375,5.03,15.305,1.1ZM17.546,6.8,15.88,5.133V1.1l3.683,3.683Zm3.216,3.216-2.81-2.81,2.017-2.017L22.779,8Zm.406.406,2.016-2.016,2.658,2.658L23.827,13.08ZM5.658,15.592l9.934-9.934,4.5,4.5a1.25,1.25,0,0,0-.3.1c-.075.035-.2.178-.164.275a.588.588,0,0,0,.219.257.3.3,0,0,0,.243.014.841.841,0,0,1,.62.147.586.586,0,0,1,.288.873,2.393,2.393,0,0,1-.354.505c-.436.5-3.137.748-3.854.355a4.644,4.644,0,0,1-1.326-1.054,6.488,6.488,0,0,0-.9-.922,2.181,2.181,0,0,0-2.857-.042.878.878,0,0,0-.394.9,1.828,1.828,0,0,0,.444,1.086c.062.055.269.35.391.363h0a.271.271,0,0,0,.331-.3l0-.023-.076-.132c-.064-.111-.119-.2-.167-.281a3.1,3.1,0,0,1-.2-.356.5.5,0,0,1,.083-.629,1.391,1.391,0,0,1,1.461-.367,2.51,2.51,0,0,1,1.05.754l.08.087c.315.345.64.7.99,1.022a.714.714,0,0,1,.3.594c-.011.421-.012.8-.013,1.163,0,.517,0,1-.03,1.586a27.431,27.431,0,0,0,.161,3.851,4.224,4.224,0,0,1-.336,2.089,1.175,1.175,0,0,1-.84.722,2.5,2.5,0,0,1-2.188-.429,1.129,1.129,0,0,1-.5-1.16c.017-.1.035-.2.053-.3.038-.215.076-.43.107-.646.043-.309-.1-.375-.449-.459l-.054-.013-.025.049a3.254,3.254,0,0,0-.306,1.682Zm9.934,9.935-2.178-2.178a3.7,3.7,0,0,0,1.039.144h.025a3.04,3.04,0,0,0,1.078-.289l.167-.067a1.362,1.362,0,0,0,.722-.77,4.748,4.748,0,0,0,.411-2.345c-.028-.36-.062-.72-.1-1.08-.03-.32-.06-.64-.086-.96a4.6,4.6,0,0,1,.042-.56A4.056,4.056,0,0,1,17.95,17.3h.13c.493,0,1.8-.01,2.319-.02.222,0,.338-.094.345-.268a.342.342,0,0,0-.275-.351,1.882,1.882,0,0,0-.457-.043l-1,.014c-.783.011-1.693.023-2.3.035a8.188,8.188,0,0,1-.007-1.491,9.082,9.082,0,0,0,.01-1.341,1.379,1.379,0,0,1,.016-.279c0-.025.006-.05.009-.074l.044-.014c.017-.006.039-.013.035-.016a10.6,10.6,0,0,0,3.115.053,2.158,2.158,0,0,0,1.346-.784,1.878,1.878,0,0,0,.424-.937l3.814,3.814ZM15.592,0,0,15.592,15.592,31.185,31.185,15.592Z"
					/>
					<path
						id="Path_4584"
						data-name="Path 4584"
						d="M119.694,185.292c-.611.008-1.216.016-1.557.024a.257.257,0,0,1-.035-.018l-.024-.013-.014-.116,0-.007c0-.139.008-.279.008-.418,0-.032,0-.064,0-.1a1.152,1.152,0,0,1,.039-.393,3.674,3.674,0,0,1,.674-.112l.33-.006.9.013c.8.011,1.8.025,2.294.039a1.81,1.81,0,0,1,.2.02c.043.006.087.009.132.013.162.012.3.022.382.169a.882.882,0,0,1,.036.763.274.274,0,0,1-.185.115,2.957,2.957,0,0,1-.393,0c-.079,0-.157-.008-.236-.008q-.45,0-.9.008c-.361.008-1.012.016-1.655.025m-1.559-2.9a5.935,5.935,0,0,1,.664,0c.07,0,.144.006.24.008.511.009.978.022,1.463.036l.621.017a1.847,1.847,0,0,1,.2.02c.043.006.087.01.132.013.162.012.3.022.382.17a.885.885,0,0,1,.036.763.275.275,0,0,1-.185.115,2.913,2.913,0,0,1-.393,0c-.078,0-.157-.008-.236-.008q-.45,0-.9.008l-.965.023c-.347.009-.693.018-1.06.025a.249.249,0,0,1-.035-.018l-.024-.013a2.845,2.845,0,0,1,.057-1.152m4.726,3.444c.545.015.8-.2.826-.688,0-.038.007-.075.011-.113a1.484,1.484,0,0,0,.013-.154,1.145,1.145,0,0,0-1.086-1.251h0l-.155-.017a1.128,1.128,0,0,0,.03-.206c0-.038.007-.075.011-.112a1.519,1.519,0,0,0,.013-.155,1.145,1.145,0,0,0-1.086-1.251c-.174-.021-.332-.034-.483-.038-.407-.011-.727-.017-1.133-.021l-.2,0c-.265,0-.539-.007-.809.005s-.531.036-.811.061l-.381.033-.047,0-.013.045c0,.013-.01.028-.016.044a.6.6,0,0,0-.048.186c-.027.551-.042.976-.05,1.379,0,.214,0,.432.014.642,0,.1.008.206.011.3-.009.233-.016.466-.022.693-.008.067-.016.135-.029.2a.66.66,0,0,0,.03.293l0,.112.041.017.038.014.006,0a.293.293,0,0,0,.277.086l.019-.006a1.776,1.776,0,0,0,.234.025l.049,0,0-.009.094-.019a1.782,1.782,0,0,1,.271-.042c.21-.01.42-.012.63-.015.241,0,.491-.006.737-.02.4-.023,1.239-.035,1.669-.038.4,0,.83,0,1.34.016"
						transform="translate(-108.653 -168.259)"
					/>
				</g>
			</g>
		</svg>
	</button>
</template>

<script setup>
defineProps({
	color: { type: String, default: 'light' },
	hidden: { type: Boolean, default: false },
});
</script>

<style lang="scss" scoped>
.cls-1 {
	transition: fill 0.3s ease;
	fill: var(--nav-color-light);
	stroke-width: 0;
}

.mobile {
	display: none;
}

.logo {
	max-width: 54px;
	opacity: 1;
	cursor: pointer;
	text-align: center;
	margin: 0;
	position: relative;
	z-index: 2;

	svg {
		width: 31px;
		height: 31px;
	}

	&.hidden {
		opacity: 0;
	}

	&.medium svg {
		.cls-1 {
			fill: var(--nav-color-dark);
		}

		&:hover .cls-1 {
			fill: #fff;
		}
	}

	&.dark svg {
		.cls-1 {
			fill: var(--cta-color-hover);
		}
	}

	&.nav-bar-logo {
		position: relative;
	}

	&.fullpage-nav-logo {
		margin-bottom: 60px;
	}
}

@media (max-width: 920px) {
	.logo {
		display: none;

		svg {
			filter: invert(95%) sepia(6%) saturate(250%) hue-rotate(349deg) brightness(97%) contrast(89%);
		}

		&.mobile {
			display: block;
		}
	}
}
</style>
